import React, { useState } from "react";
import { FaMoneyBillWave, FaCar, FaCubes, FaPaw, FaUtensils } from "react-icons/fa";
import { useTripContext } from "../TripContext";
import SummaryCars from "./SummaryCars";
import SummaryElements from "./SummaryElements";
import SummaryFinance from "./SummaryFinance";
import SummaryPets from "./SummaryPets";
import SummaryFood from "./SummaryFood";
import "../../../css/View/Summary.css";
import { groupRegistrations } from "../../../utils/VariantRegistrationsUtils";

export const Summary = () => {
  const { tripData } = useTripContext();
  const { registrations, variants, elements } = tripData;

  const [activeView, setActiveView] = useState("finance");
  const [selectedVariantGuid, setSelectedVariantGuid] = useState(variants[0]?.guid || "");

  const selectedVariant = variants.find(v => v.guid === selectedVariantGuid);
  const grouped = groupRegistrations(registrations);
  const filteredRegistrations = grouped.active.filter(r => r.variantGuid === selectedVariantGuid);
  const filteredWaitlistRegistrations = grouped.waitlist.filter(
  r => r.variantGuid === selectedVariantGuid
);
  const selectedElements = elements.filter(e => e.variants.includes(selectedVariantGuid));

  const handleViewChange = (view) => setActiveView(view);
  const handleVariantChange = (e) => setSelectedVariantGuid(e.target.value);

  return (
    <div className="summary-container">
      <div className="variant-selector">
        <select id="variant" value={selectedVariantGuid} onChange={handleVariantChange}>
          {variants.map((variant) => (
            <option key={variant.guid} value={variant.guid}>
              {variant.name}
            </option>
          ))}
        </select>
      </div>

      <div className="trip-details-buttons">
        <div className="trip-details-button-container" onClick={() => handleViewChange("finance")}>
          <div className="trip-details-button">
            <FaMoneyBillWave className="trip-details-button-icon" />
          </div>
          <span className="trip-details-button-label">Koszty</span>
        </div>

        <div className="trip-details-button-container" onClick={() => handleViewChange("cars")}>
          <div className="trip-details-button">
            <FaCar className="trip-details-button-icon" />
          </div>
          <span className="trip-details-button-label">Samochody</span>
        </div>
        <div className="trip-details-button-container" onClick={() => handleViewChange("food")}>
          <div className="trip-details-button">
            <FaUtensils className="trip-details-button-icon" />
          </div>
          <span className="trip-details-button-label">Wyżywienie</span>
        </div>

        <div className="trip-details-button-container" onClick={() => handleViewChange("pets")}>
          <div className="trip-details-button">
            <FaPaw className="trip-details-button-icon" />
          </div>
          <span className="trip-details-button-label">Zwierzęta</span>
        </div>
                      <div className="trip-details-button-container" onClick={() => handleViewChange("elements")}>
          <div className="trip-details-button">
            <FaCubes className="trip-details-button-icon" />
          </div>
          <span className="trip-details-button-label">Zajętość elementów</span>
        </div>
      </div>


      <div>
        {activeView === "cars" && <SummaryCars registrations={filteredRegistrations}  waitlistRegistrations={filteredWaitlistRegistrations} />}

        {activeView === "elements" && (
          <SummaryElements
            elements={selectedElements}
            variant={selectedVariant}
            registrations={filteredRegistrations}
            allVariants={variants}
          />
        )}

        {activeView === "finance" && (
          <SummaryFinance variant={selectedVariant} elements={selectedElements} />
        )}

        {activeView === "food" && (
          <SummaryFood registrations={filteredRegistrations} />
        )}

        {activeView === "pets" && (
          <SummaryPets registrations={filteredRegistrations} />
        )}
      </div>
    </div>
  );
};

export default Summary;
